var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayoutHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 10.9702V13.0302C22.0002 13.5802 21.5602 14.0302 21.0002 14.0502H19.0402C17.9602 14.0502 16.9702 13.2602 16.8802 12.1802C16.8202 11.5502 17.0602 10.9602 17.4802 10.5502C17.8502 10.1702 18.3602 9.9502 18.9202 9.9502H21.0002C21.5602 9.9702 22.0002 10.4202 22.0002 10.9702Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.47 15.55H19.04C17.14 15.55 15.54 14.12 15.38 12.3C15.29 11.26 15.67 10.22 16.43 9.48C17.07 8.82 17.96 8.45 18.92 8.45H20.47C20.76 8.45 21 8.21 20.97 7.92C20.75 5.49 19.14 3.83 16.75 3.55C16.51 3.51 16.26 3.5 16 3.5H7C6.72 3.5 6.45 3.52 6.19 3.56C3.64 3.88 2 5.78 2 8.5V15.5C2 18.26 4.24 20.5 7 20.5H16C18.8 20.5 20.73 18.75 20.97 16.08C21 15.79 20.76 15.55 20.47 15.55ZM13 9.75H7C6.59 9.75 6.25 9.41 6.25 9C6.25 8.59 6.59 8.25 7 8.25H13C13.41 8.25 13.75 8.59 13.75 9C13.75 9.41 13.41 9.75 13 9.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5C8.48614 12.5 10.5 14.5139 10.5 17C10.5 18.351 9.90208 19.555 8.96973 20.375L8.96875 20.377C8.17361 21.0712 7.13847 21.5 6 21.5C3.51386 21.5 1.5 19.4861 1.5 17C1.5 15.5836 2.1529 14.3108 3.18945 13.4883C3.96324 12.8719 4.9415 12.5 6 12.5ZM6.00977 17.1143L5.76562 17.2598L4.87598 17.79L4.87207 17.792C4.76329 17.8554 4.71574 18.0012 4.78906 18.1328C4.83529 18.2063 4.91883 18.25 5 18.25C5.05757 18.25 5.0939 18.2359 5.1123 18.2236L5.12207 18.2178L5.13281 18.2109L6.38281 17.4609L6.38574 17.46C6.44911 17.4225 6.5 17.3383 6.5 17.25V15.75C6.5 15.6161 6.38386 15.5 6.25 15.5C6.11365 15.5 6.00679 15.6163 6.00977 15.7383V17.1143Z",
    fill: "white",
    stroke: "#00A79D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutHistoryIcon);
export default __webpack_public_path__ + "static/media/payout-history-icon.44c23198b30cd14ca9a2940fbce0dbe9.svg";
export { ForwardRef as ReactComponent };